import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const ImageCarousel = ({ images }) => {
  return (
    <Swiper
      navigation
      pagination={{ clickable: true }}
      style={{height: '90vh', overflowY: 'auto'}}
      loop={true}
      spaceBetween={50}
      slidesPerView={1}
      breakpoints={{
        768: {  // Breakpoint for larger screens (768px and up)
          slidesPerView: 2, // Show 2 slides per vie
        },
      }}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img src={image} alt={`Slide ${index}`} style={{ width: '90%', height: '86vh' }} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageCarousel;
